module.exports = __webpack_public_path__ + "img/provetta-con-vino.fb33bace.jpg";